import { useNavigate } from "react-router-dom";
import freeImg from "../assets/free_flag.png";
import paidImg from "../assets/lock_flag.png";
import { useState } from "react";
import ToastNotification from "./ToastNotification";
import { useSelector } from "react-redux";
const Item = ({ title, image, type, id }) => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const SubscribedCourses = useSelector(
    (state) => state.home.subscribedCoures.data
  );

  const handleClick = () => {
    if (type === "Free") {
      navigate(`/test/${id}`);
    } else {
      let isValid = SubscribedCourses?.filter(
        (obj) => obj?.CoursePtr?.objectId === id
      )?.length;
      if (isValid) {
        navigate(`/test/${id}`);
      } else {
        setShow("true");
        setTimeout(() => {
          setShow(false);
        }, 5000);
      }
    }
  };
  return (
    <>
      <div
        onClick={handleClick}
        className="bg-cover bg-center cursor-pointer rounded bg-no-repeat border border-gray-300 py-4 px-2 text-center relative h-48 hover:bg-gray-100"
      >
        <img
          src={type === "Free" ? freeImg : paidImg}
          alt={type}
          className="absolute top-0 right-0 rounded-tr-md"
        />
        <div className="flex flex-col gap-5 h-full items-center">
          <div
            className="bg-cover  bg-center bg-no-repeat border border-gray-300 h-40 w-40 "
            style={{ backgroundImage: `url(${image})` }}
          ></div>
          <span className="text-sm font-semibold text-gray-800">{title}</span>
        </div>
      </div>
      {show && (
        <ToastNotification
          showToast={show}
          message="You are trying to access premium content"
          warningActive={true}
        />
      )}
    </>
  );
};

export default Item;
